import { render, staticRenderFns } from "./ListPriceRuleForm.vue?vue&type=template&id=1e1b5b4c&scoped=true"
import script from "./ListPriceRuleForm.vue?vue&type=script&lang=js"
export * from "./ListPriceRuleForm.vue?vue&type=script&lang=js"
import style0 from "./ListPriceRuleForm.vue?vue&type=style&index=0&id=1e1b5b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1b5b4c",
  null
  
)

export default component.exports